export const i18nNamespaces = [
  'activitySession',
  'common',
  'lesson',
  'lessonReportDetail',
  'signup',
  'activityReport',
  'gamification',
  'lessonComplete',
  'login',
  'splashScreen',
  'avatar',
  'leaderboard',
  'lessonDetail',
  'network',
  'userNotebook',
  'userProfile',
  'classroom',
  'lessonActivities',
  'lessonReport',
  'schoolApp',
  'portfolio',
  'liveSession',
] as const;

export type I18nNamespace = (typeof i18nNamespaces)[number];
